module.exports = __webpack_public_path__ + "img/big4-4.9c03f394.jpg";